export interface DailySchedule {
  /** When today's daily ends: the next global reset. */
  endsAt: Date;
  /** The server's clock when the schedule was issued, in epoch ms, to correct for device clock skew. */
  serverNow: number;
}

/** Where the daily puzzle schedule comes from. */
export interface DailyScheduleSource {
  getSchedule(): Promise<DailySchedule>;
}

/** The next midnight UTC strictly after `now`: the daily resets globally at 00:00 UTC. */
export const nextUtcMidnight = (now: number): Date => {
  const today = new Date(now);
  return new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate() + 1));
};

/**
 * Stub: computes the reset on the client, taking the device clock as the server's.
 * Replaced by the daily schedule API in ENG-824.
 */
export const stubDailyScheduleSource: DailyScheduleSource = {
  getSchedule: async () => {
    const now = Date.now();
    return { endsAt: nextUtcMidnight(now), serverNow: now };
  },
};
